import { Progress } from "@/components/ui/progress"
import type { Unit } from "@/services/api/cronos/tracking/students/get-situation"

interface UnitsProps {
  units: Unit[]
}
export default function Units({ units }: UnitsProps) {
  return (
    <>
      {units.map((unit) => (
        <div
          key={unit.id}
          className="flex items-center justify-between rounded-xl border bg-white px-4 py-3 shadow-sm"
        >
          <span className="font-semibold text-muted-foreground">{unit.name}</span>
          <div className="inline-flex items-center gap-2">
            <span className="text-muted-foreground">
              {Number.isInteger(unit.progress) ? unit.progress : unit.progress.toFixed(1)}%
            </span>
            <Progress
              progressClassnames="bg-primary-500"
              className="h-3 w-44 bg-border"
              value={unit.progress}
            />
          </div>
        </div>
      ))}
    </>
  )
}
